// test1382
(1382 && 0);
